import PropTypes from "prop-types";
import { StyledStatusInfo } from "../../styles/StatusInfo/StatusInfo";

export default function StatusInfo({ children }) {
	return (
		<StyledStatusInfo>
			<p>Status</p>
			<p>{children}</p>
		</StyledStatusInfo>
	);
}

StatusInfo.propTypes = {
	children: PropTypes.string.isRequired,
};
